import styled from 'styled-components';

export const Conteiner = styled.div`
    display: flex;
    width: 100%;
    padding: 1rem;
    flex-direction: column;
    table{
        width: 100%;
        text-align: left;
        border-spacing: 0;
        border-radius: 4px;
        background-color: #1D86FF;
        thead{
            color: #ffffff;
            font-size: 1rem;
            background-color: transparent;
            th{
                padding: 0.5rem;
            }
        }
        tbody{
            background-color: #ffffff;
            tr{
                &:nth-child(2n){
                background-color:#1D86FF66;
                }
                th{
                    padding: 0.5rem;
                    text-align: left;
                }
            }
        }
    }


`
export const Actions = styled.div`
    display: flex;
    width: 100%;
    height: 4rem;
    align-items: center;
    padding: 0;
    gap: 0.5rem;
    justify-content: end;
    .generatorExcel{
        cursor: pointer;
        font-size: 2rem;
        color:#1a9383;
    }
`
export const Filter = styled.div`
    display: flex;
    width: 20rem;
    min-width: 10rem;
    height: 2rem;
    border-radius: 4px;
    border: 1.5px solid #1D86FF;
    span{
        display: flex;
        width: 2rem;
        height: 100%;
        color:#1a9383;
        justify-content: center;
        align-items: center;
    }
    input{
        width: 100%;
        outline: none;
        border: none;
        background-color: transparent;
    }
    button{
        display: flex;
        width: 6rem;
        border: none;
        outline: none;
        justify-content: center;
        align-items: center;
        gap: 0.2rem;
        color:#ffffff;
        background-color:#1D86FF;
        cursor: pointer;
    }

`